<template>
		<v-card>
			<v-card-title class="headline grey lighten-2" primary-title>
				Share Screen
			</v-card-title>
			<v-card-text class="pt-2">
				I understand that by clicking "Start screen sharing" I am sharing my screen. 
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="red" text	@click="cancel">
					Cancel
				</v-btn>
				<v-btn color="primary" text	@click="start">
					Start screen sharing
				</v-btn>
			</v-card-actions>		
		</v-card>
</template>


<script>
	export default{
		name: "ShareScreen", 
		props: [],
		methods:{
			cancel: function(){
				this.$emit("cancel")
			},
			start: function(){
				this.$emit("complete")
			}
		}
	}
</script>